import { Box, Typography } from '@mui/material';
import useBreakpoints from '@ui/hooks/useBreakpoints';
import Image from 'next/image';
import React from 'react';

import useStyles from './SimpleCard.style';

interface SimpleCardProps {
  title: React.ReactNode;
  description?: string;
  imageUrl?: string;
  imageAlt: string;
}

const SimpleCard: React.FC<SimpleCardProps> = (props) => {
  const {
    title,
    description,
    imageUrl,
    imageAlt,
  } = props;

  const { classes } = useStyles();
  const { md } = useBreakpoints();

  return (
    <Box className={classes.simpleCard}>
      <Box className={classes.simpleCardTitleImage}>
        <Image
          src={imageUrl}
          alt={imageAlt}
          width={md ? 32 : 24}
          height={md ? 32 : 24}
        />
      </Box>
      <Box className={classes.simpleCardTitleTextWrapper}>
        <Typography
          className={classes.simpleCardTitleText}
        >
          {title}
        </Typography>
        {description && (
          <Typography
            variant="body1"
            style={{ fontSize: md ? 20 : 16 }}
          >
            {description}
          </Typography>
        )}

      </Box>    
    </Box>
  );
};

export default SimpleCard;
